// extracted by mini-css-extract-plugin
export default {"component":"index-module__component--49S5K","flexbox__item":"index-module__flexbox__item--XF95g","title":"index-module__title--fxzXt"};